// 存放 apifox 网站的相关的接口 https://app.apifox.com
import request from "@/utils/request";

export function qiYun() {
  return request({
    url: "/qiYun",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

export function qiYunEncryption() {
  return request({
    url: "/qiYun/encryption",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

export function tianLing() {
  return request({
    url: "/tianLing",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

export function tianLingEncryption() {
  return request({
    url: "/tianLing/encryption",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

// 公司列表
export function companyList() {
  return request({
    url: "/companyList",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

// 公司列表加密
export function companyListEncryption() {
  return request({
    url: "/companyList/encryption",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

// 解锁密码
export function password() {
  return request({
    url: "/password",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

// 博客的配置信息
export function sysConfig() {
  return request({
    url: "/sysConfig",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

// 博客导航栏
export function menuList() {
  return request({
    url: "/menuList",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

// 我的开源项目
export function openProject() {
  return request({
    url: "/openProject",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}

// 友情链接
export function friendlyLink() {
  return request({
    url: "/friendlyLink",
    method: "get",
    headers: {
      isToken: true,
    },
  });
}
